import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { Portal } from 'react-portal';

const Tooltip = ({
  text,
  children,
  className,
  isOpen,
  handleMouseEnter,
  handleMouseLeave,
  tooltipPos,
}) => (
  <div
    className={classnames(
      'c-info-tooltip-new c-info-tooltip-new-handler u-ml--',
      className,
      { 'is-active': isOpen }
    )}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
  >
    <Portal>
      <div
        className={classnames(
          'c-info-tooltip-new__content u-position-fixed',
          { 'is-active': isOpen })
        }
        style={{
          top: tooltipPos.top,
          left: tooltipPos.left,
        }}
      >
        { text || children }
      </div>
    </Portal>
  </div>
);

Tooltip.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
  tooltipPos: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }).isRequired,
};

Tooltip.defaultProps = {
  className: '',
  text: '',
  children: null,
};

export default Tooltip;
